module.exports = __webpack_public_path__ + "img/operator.5fdf2d9d.png";